import Branding from "../components/auth/Branding";
import LoginForm from "../components/auth/login/LoginForm";
const Login = () => {
  return (
    <div className="min-h-screen flex bg-white">
      <Branding />
      <div className="w-full lg:w-1/2 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <LoginForm />
        </div>
      </div>
    </div>
  );
};

export default Login;
